import type { CSSObjectWithLabel } from "react-select";

export const formSelectOptionStyles = (
	_styles: CSSObjectWithLabel,
	{ isFocused }: { isFocused: boolean },
): CSSObjectWithLabel => ({
	display: "flex",
	fontFamily: "Work Sans",
	alignItems: "center",
	height: 32,
	paddingLeft: 8,
	borderTop: "1px solid #f4f4f4",
	backgroundColor: isFocused ? "#faf5e6" : "white",
});

export const formSelectControlStyles = (
	base: CSSObjectWithLabel,
): CSSObjectWithLabel => ({
	...base,
	fontFamily: "Work Sans",
	// border: 0,
	boxShadow: "none",
});
